import BarekamInputWithSelect from "./input-with-select";

export default BarekamInputWithSelect;